export const fieldTranslations = {
  client: "Client",
  vehicle: "Véhicule / Bénéficiaire du compte",
  account_name: "Groupe de comptes",
  short_account_name: "Nom court du compte",
  name: "Compte",
  currency: "Devise du portefeuille",
  reporting_currency: "Devise de reporting",
  bank_name: "Banque",
  account_type: "Type de compte",
  investment_type: "Type d'investissement",
  contract_name: "Nom du contrat",
  code: "Code",

  has_pdf_bank_page: "Page du compte dans le rapport PDF",
  display_performance_report: "Page de la performance dans le rapport PDF",

  collateral: "Compte-titres nanti",
  strategy_id: "Id de la stratégie",

  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
